import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
    const token = localStorage.getItem('vg_token');
    if (token) {
        cfg.headers.Authorization = `Bearer ${token}`;
    }
    return cfg;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err.response && err.response.status === 401) {
            const onLogin = window.location.pathname === '/login';
            if (!onLogin) {
                localStorage.removeItem('vg_token');
                localStorage.removeItem('vg_user');
                window.location.assign('/login');
            }
        }
        return Promise.reject(err);
    }
);

export default api;
